<template>
  <Layout :linksData="linksData">
    <v-row class="leads-managements w-100">
      <v-col cols="12" :lg="6" :sm="6" class="header-line-title"> events </v-col>
      <v-col cols="12" :lg="6" :sm="6" class="d-flex align-center justify-end ga-2">
        <Top :type="'Event'" :list="events" />
      </v-col>
    </v-row>
    <FilterSection
      :selected_rows="selected_events"
      @update:selected_rows="selected_events = $event"
      :menu="[]"
      :assign_to_account_menu="false"
      :parent="'events'"
      :dashboard_path_name="'EventsDashboard'"
      @update:search="updateSearch"
      :store="store"
    />
    <div class="table mt-3">
      <DataTable
        @update:selected_events="selected_events = $event"
        :events="events"
      />
    </div>
  </Layout>
</template>
<script>
import Layout from "@/components/crm/layouts/Layout.vue";
import activityLogIcon from "@/assets/images/icons/activity-log.svg";
import discussionsIcon from "@/assets/images/icons/discussions.svg";
import importIcon from "@/assets/images/icons/import.svg";
import FilterSection from "@/components/crm/assets/Filter.vue";
import Top from "@/components/crm/assets/Top.vue";
import DataTable from "@/components/crm/events/table.vue";
import "@/assets/css/crm/crm-moduls.css";
import { useEventsStore } from "@/store/crm/useEventsStore";

export default {
  components: {
    Layout,
    FilterSection,
    Top,
    DataTable,
  },

  data() {
    return {
      selected_events: [],
      activityLogIcon,
      discussionsIcon,
      importIcon,
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "events Management", link: "" },
      ],
      store: null,
    };
  },
  methods: {
    updateSearch(data) {
      this.store.search = data;
      this.store.getAllEvents();
    },
  },
  computed: {
    events() {
      return this.store?.getEvents || [];
    },
  },
  created() {
    this.store = useEventsStore();
    if (this.store?.getEvents.length === 0) {
      this.store?.getAllEvents();
    }
  },
};
</script>
